// extracted by mini-css-extract-plugin
module.exports = {"routeLengthStops":"Route_routeLengthStops__3e5_h","route":"Route_route__3sy5i","time":"Route_time__2IiqQ"};